import React,{Component} from 'react';

import './App.css';
import WorkerView from './WorkerView';
import UserListView from './UserListView';
import ForemanView from './ForemanView';
import ForemanConfigView from './ForemanConfigView';
import PostingListView from './PostingListView'
import AddWorkerView from './AddWorkerView';
import LoginView from './LoginView';

import BounceLoader from "react-spinners/BounceLoader";
import MapView from './MapView';
import Notification from './Notification';
import API from './API';
import {isMobile} from 'react-device-detect';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  Params,
  IndexRoute,
  match
} from "react-router-dom";
import OmattiedotDialog from './OmattiedotDialog';
import AddUserView from './AddUserView';
const SafeGuardApi = new API();

const loaderCss = {
  display: 'block',
  margin: 'auto',
  position:'absolute',
  left:'30%',
  top:'30%',
  width:'50pt',
  height:'50pt',
  opactity: 0.5 
}
;
class App extends Component {
  constructor(props, context) {
    super(props, context);
    let timeConfigs =  {workTime:localStorage.workTime,employeeNotice:localStorage.employeeNotice,foremanNotice:localStorage.foremanNotice,currentUser:null};
    this.state = {createAccessToken:false,working:localStorage.working === "true",loading:false,
    timeConfigs:timeConfigs,
     redirect: window.location.pathname,workerLoginSuccess:false,interval:null,
    workers:[]
  };
    this.isForeman = window.location.pathname.indexOf("/worker") == -1 &&  (window.localStorage.accessToken === undefined || window.localStorage.accessToken === null);
    console.log("1:" + this.isForeman);
    this.closeApplication  = this.closeApplication.bind(this);
    this.setToWork  = this.setToWork.bind(this);
    this.setToOutOfWork  = this.setToOutOfWork.bind(this);
    this.getLocation  = this.getLocation.bind(this);
    this.setPositionToState  = this.setPositionToState.bind(this);
    this.changeToConfigView = this.changeToConfigView.bind(this);
    this.changeToAddWorkerView = this.changeToAddWorkerView.bind(this);
    this.changeToPostingView = this.changeToPostingView.bind(this);

    this.setTimeConfig = this.setTimeConfig.bind(this);
    this.saveWorker = this.saveWorker.bind(this);
    this.doLogin = this.doLogin.bind(this);
    this.changeToEmployeesView = this.changeToEmployeesView.bind(this);
    this.changeToLoginView = this.changeToLoginView.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.setNotification = this.setNotification.bind(this);
    this.hideNotification =this.hideNotification.bind(this);
    SafeGuardApi.doConnectionTest( this.showNotification, this.showNotification);
    this.changeWorker = this.changeWorker.bind(this);
    this.addWorker = this.addWorker.bind(this);
    this.deleteWorker = this.deleteWorker.bind(this);
    this.updateEmployeesView = this.updateEmployeesView.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.setAccessToken = this.setAccessToken.bind(this);
    this.updateEmployeeList = this.updateEmployeeList.bind(this);
    this.changePasswordView = this.changePasswordView.bind(this);
    this.deletePosting = this.deletePosting.bind(this);
    this.savePosting = this.savePosting.bind(this);
    this.showInMap = this.showInMap.bind(this);
    this.playNotice = this.playNotice.bind(this);
    this.noticeAudio = React.createRef();
    this.setcreateAccessTokenToFalse = this.setcreateAccessTokenToFalse.bind(this);
    this.changeToNewWorker = this.changeToNewWorker.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.changeToAddUserView = this.changeToAddUserView.bind(this);
    this.changeToUsersView = this.changeToUsersView.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.sendTestMessageToUser = this.sendTestMessageToUser.bind(this);
    let _this = this;
    if( this.isForeman){
      SafeGuardApi.isAuthenticated((data) => {
        _this.setState({isAdmin:data.user.isAdmin});
        this.changeToEmployeesView();
      },this.changeToLoginView); 
    }else{
     
    }
  }
  sendTestMessageToUser(user){
    SafeGuardApi.sendTestMessageToUser(user,this.showNotification,this.showNotification);
  }
  changeToAddUserView(){
    
    this.setState({redirect: "/addUser"})
  };

  savePosting(posting,createNewToken){
    let _this = this;
    const postingToBeSaved = posting;
    console.log("Saving posting");
    console.log(postingToBeSaved);
    if(createNewToken){
    SafeGuardApi.savePostingAndCreateNewToken(postingToBeSaved,function(){
      _this.showNotification("Tallennus onnistui");
      SafeGuardApi.getPostings(function(postings){
        _this.setState({postings:postings});
        
        },_this.showNotification);
  

    },_this.showNotification);
  }else{
    SafeGuardApi.savePosting(postingToBeSaved,function(){
      _this.showNotification("Tallennus onnistui");
      SafeGuardApi.getPostings(function(postings){
        _this.setState({postings:postings});
        
        },_this.showNotification);
  

    },_this.showNotification);
  }
  
  }
  deletePosting(posting){
    let _this = this;
    console.log("Delete posting");
    console.log(posting);
    SafeGuardApi.deletePosting(posting,function(){_this.showNotification("Poisto onnistui")},this.showNotification);
    SafeGuardApi.getPostings(function(postings){
      _this.setState({postings:postings});
      
      },this.showNotification);

  }
  
  changeToUsersView(){
    let _this = this;
    SafeGuardApi.getUsers((users)=> {
      this.setState({users:users});
      _this.setState({redirect: "/users"});
    },this.showNotification);
  };
  changePasswordView(){
    
    this.setState({redirect: "/Omattiedot"})
  }
  changePassword(oldPwd,newPwd){

    SafeGuardApi.changePassword(oldPwd,newPwd,this.changeToEmployeesView,this.showNotification);
  }

  setcreateAccessTokenToFalse(){
    this.setState({createAccessToken:false});
    
  }
  getAccessToken(){
    let accessToken =  window.location.href.split('/')[window.location.href.split('/').length - 1];
    if(accessToken){
      SafeGuardApi.registerWorker(accessToken,this.setAccessToken,(param) => {
        SafeGuardApi.isValidToken( window.localStorage.accessToken,this.setAccessToken,this.showNotification );
      });
      
    }else{
      SafeGuardApi.isValidToken( window.localStorage.accessToken,this.setAccessToken,this.showNotification );
      
    }
  }
  setAccessToken(accessToken){
    window.localStorage.accessToken = accessToken; 
    this.setState({workerLoginSuccess:true});
  }
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.setPositionToState);
    }
  }
  componentDidMount(){
  
    if(this.isForeman){
      let _this = this;
      SafeGuardApi.getWorkers((workers) => 
      {
        this.setState({workers:workers});
      
      },this.showNotification);
      SafeGuardApi.getTimeConfig((timeConfigs) => {
        this.setState({timeConfigs:timeConfigs});
      },this.showNotification);
      if(this.state.interval != null) clearInterval(interval);
      let interval = setInterval(()=> {
      
  
        if(_this.state.redirect =="/employees"){

          this.updateEmployeeList();
        }

      },20000);

  

      this.setState({interval:interval});
    
    }else{
      this.getAccessToken();

    }
    
  }
  

  setPositionToState(position) {
    console.log(position);
    
    let _this = this;
    this.setState({latitude:position.coords.latitude,longitude:position.coords.longitude })
    if(this.state.firstLocationNoticed == false){
      this.showNotification("Aloitus sijainti tallennettu! " + position.coords.latitude + "," + position.coords.longitude);
      this.setState({firstLocationNoticed:true});
    }
    SafeGuardApi.saveWorkerLocation({latitude:position.coords.latitude,longitude:position.coords.longitude },
      (param) => {
       
      }
      ,(param) =>{
    


      }
      );
/*
      setTimeout(function(){
        window.navigator.vibrate(2000);
        SafeGuardApi.notifyWorker((playNotice) => {
          if(playNotice == true){
           // _this.playNotice();
          }
  
      },() => {});
      },1000);*/

  
  }
  closeApplication(){
    window.close();
  }
  setToWork(){
    let _this = this;
    this.setState({working: true,firstLocationNoticed:false})
    localStorage.working = true;

    this.getLocation();
    ///navigator.geolocation.watchPosition(this.setPositionToState,() =>{});
    SafeGuardApi.startWorking(() => {
   

    },() => {});
  
  }
  setToOutOfWork(){
    this.setState({working: false,firstLocationNoticed:false})
    localStorage.working = false;
    this.hideNotification();
    SafeGuardApi.stopWorking(() => {},() => {});
 

    
  }
  changeToConfigView(){
    this.setState({ redirect: "/timeConfigs" });
  }
  changeToAddWorkerView(){

    this.setState({redirect: "/addWorkerView"})
      

  }
  changeToPostingView(){
    let _this  = this;
    SafeGuardApi.getPostings(function(postings){
      _this.setState({postings:postings});
      
      },this.showNotification);

    this.setState({redirect: "/postingView"})
      

  }
  changeToLoginView(){
    this.showNotification("");
    this.setState({redirect: "/"})

}
changeToEmployeesView(){
  this.setState({ redirect: "/employees" });

}
updateEmployeeList(){
  let _this = this;
  /*setTimeout(function(){
    console.log("Should I notify");
    SafeGuardApi.notifyForeman((playNotice) => {
      if(playNotice == true){
        _this.playNotice();
      }

    },()=> {});
  },2000);*/

  SafeGuardApi.getWorkers((workers) => 
  {
    this.setState({workers:workers});
   
 
  
  },this.showNotification);
 

}
  updateEmployeesView(){
    let _this  = this;
    SafeGuardApi.getTimeConfig((timeConfigs) => {
      _this.setState({timeConfigs:timeConfigs});
    },(eatIt) => {});

    this.setState({loading:false});
    this.updateEmployeeList();
    this.changeToEmployeesView();
  }


  saveUser(user){
    let _this = this;
    console.log(user);
    SafeGuardApi.saveUser(user,(savedUser) => {
      
    
         
          this.changeToUsersView(); 

      
    },this.showNotification);    
  }

  saveWorker(worker){
    let _this = this;
    console.log(worker);
    SafeGuardApi.saveWorker(worker,(savedWorker) => {
      
      if(worker._id == undefined){
        console.log("New worker saved");
        SafeGuardApi.createNewTokenForWorker(savedWorker,(newAccessToken) => {
      
          let newWorker = savedWorker;
          newWorker.accessToken = newAccessToken
          this.changeToNewWorker(newWorker); 
     
         },() => {
     
         });
      
      }else{
        
        console.log("Old worker saved");
        this.changeWorker(savedWorker);
      } 

    
    
      
    },this.showNotification);    
  }

  
  deleteWorker(worker){
    SafeGuardApi.deleteWorker(worker,this.updateEmployeesView,this.showNotification);


    
  }
  
  changeToNewWorker(worker){
    console.log("worker:" + worker);
    this.setState({worker:worker,createAccessToken:true});
    this.changeToEmployeesView();
    this.changeToAddWorkerView();
  }


  
  changeWorker(worker){
    this.setState({worker:worker});
    this.changeToAddWorkerView();
  }

  addWorker(){
    this.setState({worker:{workerName:"",phonenumber:"",email:""}});
    this.changeToAddWorkerView();
  }
  
  setTimeConfig(timeConfigs){

      this.setState({timeConfigs: timeConfigs});
      SafeGuardApi.saveTimeConfig(timeConfigs,() => {

      },() => {
        
      });
     this.changeToEmployeesView();
  }
  doLogin(users){
    this.setState({loading:true});
    let _this = this;
    SafeGuardApi.doLogin(users,(data) => {
      _this.setState({isAdmin:data.isAdmin});
      this.updateEmployeesView();


      if(data.isAdmin){
      SafeGuardApi.getUsers((users) => 
      {
        this.setState({users:users});
      
      },this.showNotification);
    }

 
    },this.showNotification);
  }

  isAuthenticated(users){

    SafeGuardApi.doLogin(users,this.changeToEmployeesView,this.showNotification);
  }
  setNotification(notification){
    
    this.setState({notification:notification});
  }
  showNotification(notification){
    
    this.setNotification(notification);
    this.setState({showNotification:true,loading:false});
    let _this = this;
    setTimeout(function(){
      _this.hideNotification();
    },5000);
  }
  showInMap(location,worker){
    this.setState({ redirect: "/showInMap",location:location,worker:worker });
  }
  hideNotification(){
    this.setNotification("");
    this.setState({showNotification:false});
  }
  playNotice(){
   this.noticeAudio.play();
  }
    render(){

      const workers= this.state.workers;
      const users = this.state.users ? this.state.users : null;
      const postings = this.state.postings ? this.state.postings : null;
      const firstView = this.isForeman ? <LoginView doLogin={this.doLogin}/> :   <WorkerView showNotification={this.state.working}  showWorkerButton={this.state.workerLoginSuccess}  closeApplication={this.closeApplication} setToWork={this.setToWork} working={this.state.working} setToOutOfWork={this.setToOutOfWork}/>;
       
     // if (isMobile) {
      return(

        <div className="App">
          <audio id="audio"  ref={(noticeAudio) => { this.noticeAudio = noticeAudio; }} ><source src="../notice.mp3" type="audio/mp3"></source></audio>
          <BounceLoader
            css={loaderCss}
          size={150}
          color={"#003300"}
          loading={this.state.loading}
        />
      <Notification showNotification={this.state.showNotification} notification={this.state.notification}/>
     
      <Redirect to={this.state.redirect} />
        <Switch>
        <Route path="/worker" exact>
          <WorkerView showNotification={this.state.working}  showWorkerButton={this.state.workerLoginSuccess}  closeApplication={this.closeApplication} setToWork={this.setToWork} working={this.state.working} setToOutOfWork={this.setToOutOfWork}/>
        </Route>
        <Route path="/worker/:accessToken" exact >
          <WorkerView showNotification={this.state.working} showWorkerButton={this.state.workerLoginSuccess} closeApplication={this.closeApplication} setToWork={this.setToWork} working={this.state.working} setToOutOfWork={this.setToOutOfWork}/>
        </Route>
        <Route path="/" exact>
          {firstView}
          
        </Route>
        <Route path="/employees" exact >
          <ForemanView workers={workers}  closeApplication={this.closeApplication}  changeToUsersView={this.changeToUsersView}  changeToConfigView={this.changeToConfigView} changeToAddWorkerView={this.addWorker} changeToPostingView={this.changeToPostingView} changeWorker={this.changeWorker}  deleteWorker={this.deleteWorker} showInMap={this.showInMap} changePasswordView={this.changePasswordView} isAdmin={this.state.isAdmin}/>
        </Route>
        <Route path="/users" exact >
          <UserListView users={users} sendTestMessageToUser={this.sendTestMessageToUser} closeApplication={this.closeApplication}  changeToUsersView={this.changeToUsersView} changeToAddUserView={this.changeToAddUserView}   changeToEmployeesView={this.changeToEmployeesView}/>
        </Route>
        <Route path="/postingView" exact >
          <PostingListView postings={postings} closeApplication={this.closeApplication}  changeToUsersView={this.changeToUsersView} changeToEmployeesView={this.changeToEmployeesView} savePosting={this.savePosting} deletePosting={this.deletePosting}/>
        </Route>

        
        <Route path="/addUser" exact >
          <AddUserView  closeApplication={this.closeApplication}  changeToUsersView={this.changeToUsersView} saveUser={this.saveUser}/>
        </Route>
        <Route path="/timeConfigs" exact>
          <ForemanConfigView timeConfigs={this.state.timeConfigs}  setTimeConfig={this.setTimeConfig}  changeToEmployeesView={this.changeToEmployeesView}/>
        </Route>
        <Route path="/showInMap" exact>
          <MapView changeToEmployeesView={this.changeToEmployeesView} location={this.state.location} worker={this.state.worker}/>
        </Route>
        <Route path="/AddWorkerView" exact>
          <AddWorkerView saveWorker={this.saveWorker} changeToEmployeesView={this.changeToEmployeesView} worker={this.state.worker} deleteWorker={this.deleteWorker } createAccessToken={this.state.createAccessToken} setcreateAccessTokenToFalse={this.setcreateAccessTokenToFalse} isAdmin={this.state.isAdmin}/>
        </Route>
        <Route path="/OmatTiedot" exact>
          <OmattiedotDialog  changePassword={this.changePassword} changeToEmployeesView={this.changeToEmployeesView} showNotification={this.showNotification}/>
        </Route>

    </Switch>


      </div>
      );
     /* }else{
        return(
        <></>
          )
      }*/ 
  }
}

export default App;
